/**
 * ClientWhoThisIsFor Component
 * Section 6: Who This Is For / Not For
 */

import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

export const ClientWhoThisIsFor: React.FC = () => {
  const scrollToForm = () => {
    const element = document.getElementById('execution-fit-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const forConsultants = [
    'Work on execution, alignment, or transformation',
    'Care about what happens after the engagement',
    'Want a repeatable execution backbone across clients',
    'Work with multi-team or multi-function organizations',
    'Value leadership-grade visibility into progress'
  ];

  const notForConsultants = [
    'Trainers or certification-focused practices',
    'Template-driven or content-only coaching',
    'DIY OKR experimentation',
    'Small teams looking for task or project management tools'
  ];

  return (
    <section className="bg-white py-20 md:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">

          {/* Headline */}
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-stone-900 mb-12 leading-tight">
            This works best when execution outcomes matter.
          </h2>

          {/* Content */}
          <div className="space-y-12">

            {/* OKR Hub IS FOR */}
            <div>
              <h3 className="text-2xl font-display text-stone-900 mb-6">
                OKR Hub is for consultants who:
              </h3>
              <ul className="space-y-4">
                {forConsultants.map((item, index) => (
                  <li key={index} className="flex items-start text-lg text-stone-700">
                    <CheckCircle2 className="w-6 h-6 text-green-600 mr-3 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* OKR Hub IS NOT FOR */}
            <div>
              <h3 className="text-2xl font-display text-stone-900 mb-6">
                OKR Hub is not for:
              </h3>
              <ul className="space-y-4">
                {notForConsultants.map((item, index) => (
                  <li key={index} className="flex items-start text-lg text-stone-700">
                    <XCircle className="w-6 h-6 text-red-600 mr-3 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Intentional Filter */}
            <div className="bg-stone-50 border-2 border-stone-200 rounded-xl p-8">
              <p className="text-xl md:text-2xl text-stone-900 font-medium">
                If this filter feels uncomfortable, that's intentional.
              </p>
            </div>

          </div>

          {/* CTA */}
          <div className="mt-12">
            <button
              onClick={scrollToForm}
              className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-stone-900 border-2 border-stone-300 rounded-lg hover:border-stone-900 hover:bg-stone-50 transition-all duration-300"
            >
              Check fit before we talk
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};
